<template>
    <section class="landscape-tab-products-wrap zone22 clearfix container">
        <div class="container">
            <div class="tab-products-header clearfix">
                <h2 class="section-title float-left" v-html="data.title"></h2>

                <ul class="tabs float-right">
                    <li v-for="(tab, index) in tabs" :key="index" :class="classes(tab)" @click="change(tab.url)">
                        {{ tab.label }}
                    </li>
                </ul>
            </div>

            <div class="tab-content landscape-right-tab-products">
                <ProductCard v-for="product in products" :key="product.id" :product="product" />
            </div>
        </div>

        <dynamic-tab v-for="(tabLabel, index) in data.tabs" :key="index" :label="tabLabel"
            :url="route('storefront.tab_products.index', { sectionNumber: 2, tabNumber: index + 1 })">
        </dynamic-tab>

        <div align="center" style="margin-top:25px;">
            <a class="btn btn-primary btn-deals" href="" id="GroupeCatProd2">Découvrir</a>
        </div>
    </section>
</template>

<script>
import ProductCard from '../ProductCard.vue';
import DynamicTabsMixin from '../../mixins/DynamicTabsMixin';

export default {
    components: { ProductCard },

    mixins: [DynamicTabsMixin],

    props: ['data'],

    mounted() {
        this.change2(this.data.urlbtn);
    },



    methods: {

        selector() {
            return $('.landscape-right-tab-products');
        },
        change2(url) {
 
            document.getElementById('GroupeCatProd2').setAttribute('href', url);

        },
        slickOptions() {
            return {
                rows: 0,
                dots: true,
                arrows: true,
                infinite: true,
                autoplay: true,
                speed: 5000,
                autoplay_speed: 5000,
                slidesToShow: 6,
                slidesToScroll: 6,
                rtl: window.FleetCart.rtl,
                responsive: [
                    {
                        breakpoint: 1761,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5,
                        },
                    },
                    {
                        breakpoint: 1301,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 1051,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 881,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 641,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                ],
            };
        },
    },
};
</script>
